import React from "react";
import { MdEmail, MdPhone } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";

const CourseRegistrationModal = ({ selectedCourse, closeModal }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative animate-fadeIn text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          Enquire Now
        </h2>
        <p className="text-gray-600 mb-6">
          You have selected <strong>{selectedCourse}</strong>. To enroll or know more, please contact us directly using any of the methods below.
        </p>

        <div className="space-y-4 mb-6">
          <a
            href="tel:+918012003040"
            className="flex items-center justify-center gap-2 bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition"
          >
            <MdPhone className="text-red-600 text-xl" /> +91 8012003040
          </a>
          <a
            href="tel:+917449203040"
            className="flex items-center justify-center gap-2 bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition"
          >
            <MdPhone className="text-red-600 text-xl" /> +91 7449203040
          </a>
          <a
            href="mailto:selvasiasacademy@gmail.com"
            className="flex items-center justify-center gap-2 bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition"
          >
            <MdEmail className="text-red-600 text-xl" /> selvasiasacademy@gmail.com
          </a>
          <a
            href="https://wa.me/918012003040"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-green-500 text-white p-3 rounded-lg hover:bg-green-600 transition"
          >
            <FaWhatsapp className="text-xl" /> Chat on WhatsApp
          </a>
        </div>

        {/* Close button */}
        <button
          onClick={closeModal}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-lg"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default CourseRegistrationModal;
